import memoize from 'lodash/memoize';
import forEach from 'lodash/forEach';
import random from 'lodash/random';
import values from 'lodash/values';
import flatMap from 'lodash/flatMap';
import colors from 'overrides/colors.json';
import {
  isEmptyString,
} from '@populateui/utils';

const flatColors: Record<string, string> = {};
forEach(colors, (tones, colorKey) => {
  if (typeof tones === 'string') return;

  forEach(tones, (color, toneKey) => {
    flatColors[`${colorKey}-${toneKey}`] = color ?? '#787878';
  });
});
export const getColorByName = memoize(
  (colorName?: string, defaultColor: string = 'gray-200') => (
    flatColors[colorName ?? 'gray-200'] ?? flatColors[defaultColor]
  ),
);

const colorList: string[] = flatMap(
  colors,
  (colorsByTone: string | Record<string, string>, k) => (
    typeof colorsByTone !== 'string' && !k.includes('populate')
      ? values(colorsByTone).slice(4) : []
  ),
);
export const getColorForUnique = memoize((unique: string | null): string => {
  const index = random(0, colorList.length - 1);
  return colorList[index];
});

export const getColorForString = memoize((str: string, colorArray: readonly string[]): string => {
  const invalid = isEmptyString(str) || colorArray.length === 0;
  let index = 0;

  let hash = 5381;
  if (!invalid) {
    for (let i = 0; i < str.length; i += 1) {
      hash = hash * 33 + str.charCodeAt(i);
    }
    index = (hash + str.length) % colorArray.length;
  }
  return colorArray[index];
});

export function lightenHexColor(hex: string, amount: number): string {
  // Normalize hex (remove # if present)
  hex = hex.replace(/^#/, '');

  // Parse r, g, b
  let r = parseInt(hex.substring(0, 2), 16);
  let g = parseInt(hex.substring(2, 4), 16);
  let b = parseInt(hex.substring(4, 6), 16);

  // Increase towards 255 by percentage
  r = Math.min(255, Math.floor(r + (255 - r) * (amount / 100)));
  g = Math.min(255, Math.floor(g + (255 - g) * (amount / 100)));
  b = Math.min(255, Math.floor(b + (255 - b) * (amount / 100)));

  // Convert back to hex and return
  const toHex = (c: number) => c.toString(16).padStart(2, '0');
  return `#${toHex(r)}${toHex(g)}${toHex(b)}`;
}
